import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { pageAction } from '../../redux_files/actions/page_actions';
import BlogsTiles from '../../components/blog-tile';

const Blogs = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = 'Blogs';
    dispatch(pageAction('Blogs'));
  });
  return (
    <>
      <div className='container'>
        <BlogsTiles />
      </div>
    </>
  );
};
export default Blogs;
